import { X, Trash, SquarePen, User } from "lucide-react"
import styles from "./ModalDataCar.module.css"
import { useState } from "react";
import SectionRegister from "../SectionRegister";

function ModalDataTec({ setIsOpen, thisTec, setIsOpenEdit, setIsOpenDelete }) {
    const [sectionSelected, setSectionSelected] = useState("Registro");

    const dataRegister = [
        {
            label: "ID",
            value: thisTec.id,
        },
        {
            label: "NOME",
            value: thisTec.name,
        },
        {
            label: "SETOR",
            value: thisTec.setor,
        },
        {
            label: "PLACA CARRO RES.",
            value: thisTec.car === null || thisTec.car === undefined ? "----------" : thisTec.car.placa,
        }
    ]


    return (
        <div className={styles.container}>
            <div className={styles.form}>
                <div className={styles.containerHeader}>
                    <div className={styles.extra}>
                        <div className={styles.icon}>
                            <User color="#fff" size={28} />
                        </div>
                        <div className={styles.infoHeader}>
                            <h3>{thisTec.name}</h3>
                            <div className={styles.infoCar}>
                                <p>{thisTec.car === null ? "----------" : thisTec.car.placa}</p>
                                <p>{`ID: ${thisTec.id}`}</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.x}>
                        <X onClick={() => setIsOpen(false)} color="#fff" />
                    </div>
                </div>
                <div className={styles.options}>
                    <button
                        className={sectionSelected == "Registro" ? `${styles.btnOptSelect} ${styles.active}` : styles.btnOpt}
                        onClick={() => setSectionSelected("Registro")}
                    >
                        Registro
                    </button>
                </div>
                <div className={styles.content}>
                    {sectionSelected == "Registro" && (
                        <SectionRegister
                            thisEntity={dataRegister}
                            descExtra={[
                                {
                                    label: "EMAIL",
                                    value: thisTec.email,
                                },
                                {
                                    label: "CELULAR",
                                    value: thisTec.number,
                                },
                            ]}
                        />
                    )}
                </div>
                <div className={styles.buttonOperations}>
                    <button
                        className={styles.edit}
                        onClick={() => {
                            setIsOpen(false)
                            setIsOpenEdit(true)
                        }}
                    >
                        <SquarePen size={14} color="#1d121b" />
                        Editar
                    </button>
                    <button
                        className={styles.delete}
                        onClick={() => {
                            setIsOpen(false);
                            setIsOpenDelete(true)
                        }}
                    >
                        <Trash size={14} color="#fff" />
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ModalDataTec;